import { LeaveTransaction } from "../../types/LeaveTransaction";
import {
  LeaveTransactionActions,
  LeaveActionList,
} from "../actions/leaveTransactionAction";

const initialState: LeaveTransaction[] = [];

export const leaveTransactionReducer = (
  state: LeaveTransaction[] = initialState,
  action: LeaveTransactionActions,
): LeaveTransaction[] => {
  switch (action.type) {
    case LeaveActionList.ADD_LEAVE:
      return [...state, action.data];

    case LeaveActionList.EDIT_LEAVE:
      return state.map((l) =>
        l.id === action.data.id ? { ...action.data } : l,
      );

    case LeaveActionList.FETCH_LEAVES:
      return action.data;

    case LeaveActionList.FETCH_LEAVE_BAL:
      return action.data;

    case LeaveActionList.DELETE_LEAVE:
      return state.filter((l) => l.id !== action.data);

    default:
      return state;
  }
};
